import React, { useState, Fragment, useRef, useEffect } from 'react'
import ProfilePicture from '../ProfilePicture/ProfilePicture'
import Icon from '../Icon'
import './Stats.scss'
import { fetchSubscribe, fetchUserSubscribers, fetchUserSubscriptions } from '../../Reducers/actions/creationsActions'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getProfilePublicPath } from '../../../helpers/profilePaths'
import { getUserDisplayName } from '../../../helpers/userDisplayName'
import Unsubscribe from '../Unsubscribe/Unsubscribe'

const MENU_ITEMS = [
    {
        name: 'subscribers',
        label: 'Subscribers',
        value: 'subscribers_number',
        list: 'subscribers'
    },
    {
        name: 'subscriptions',
        label: 'Subscriptions',
        value: 'subscriptions_number',
        list: 'subscriptions'
    },
    {
        name: 'contributors',
        label: 'Contributors',
        value: 'nbContributors',
        list: 'contributors'
    },
    {
        name: 'contributions',
        label: 'Contributions',
        value: 'nbContributions',
        list: 'contributions'
    }
]

const SubPage = ({ list, list_used, fromProfile = false, user_id, loading }) => {
    const dispatch = useDispatch()
    const { auth_user_id, user, view_user } = useSelector((state) => ({
        auth_user_id: state.auth.user?.user_id,
        user: state.auth.user,
        view_user: state.creation.view_user
    }))
    const navigate = useNavigate()
    
    // Fetch data on demand if not loaded
    useEffect(() => {
        if (user_id && view_user && !loading) {
            if (list_used === 'subscribers' && view_user.subscribers === undefined) {
                dispatch(fetchUserSubscribers(user_id))
            } else if (list_used === 'subscriptions' && view_user.subscriptions === undefined) {
                dispatch(fetchUserSubscriptions(user_id))
            }
        }
    }, [list_used, user_id, view_user, loading, dispatch])
    const handleSubscribeUnsubscribe = (subscribed_to_id, subscribe = true, user) => {
        dispatch(fetchSubscribe(subscribed_to_id, subscribe))
        if (!fromProfile) {
            dispatch({ type: 'SUBSCRIBE_SUCCESS_FROM_OTHERS', payload: { subscribe, subscriber_id: auth_user_id, subscribed_to_id, user: { ...user, is_subscribed: subscribe }, list_used } })
        } else {
            dispatch({ type: 'SUBSCRIBE_SUCCESS_FROM_PROFILE', payload: { subscribe, subscriber_id: auth_user_id, subscribed_to_id, user: { ...user, is_subscribed: subscribe }, list_used } })
        }
    }
    
    if (loading) {
        return (
            <div className='d-flex f-column aic jcc py-48'>
                <div className="loading-dots loading-dots-red">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
                <p className='fs-regular fg-grey mt-16'>Loading...</p>
            </div>
        )
    }
    
    if (!list || list.length === 0) {
        return (
            <div className='d-flex f-column aic jcc py-48 px-16'>
                <p className='fs-regular fg-grey ta-center'>No {list_used === 'subscribers' ? 'subscribers' : list_used === 'subscriptions' ? 'subscriptions' : list_used} found</p>
            </div>
        )
    }
    
    return (
        <>
            {(list || []).map((item) => (
                <UserItem 
                    key={item.user_id || item.id} 
                    item={item} 
                    fromProfile={fromProfile}
                    user={user}
                    view_user={view_user}
                    handleSubscribeUnsubscribe={handleSubscribeUnsubscribe}
                />
            ))}
        </>
    )
}
        



const UserItem = ({ item, fromProfile = false,user,view_user ,handleSubscribeUnsubscribe}) => {
    const navigate = useNavigate()
    const [showUnsubscribe, setShowUnsubscribe] = useState(false)
    const [isSubscribed, setIsSubscribed] = useState(() => {
        return user?.subscriptions?.some(sub => sub.user_id === item.user_id)
            
    });
    const handleSubscribe = () => {
        if(isSubscribed){
            setShowUnsubscribe(true)
            return
        }
        handleSubscribeUnsubscribe(item.user_id, !isSubscribed, item)
        setIsSubscribed(!isSubscribed);
        // Call API
    };
    const goProfile = () => {
        const p = getProfilePublicPath(item);
        if (p) navigate(p);
    };
    return <><div className='sub-page d-flex aic jcc mb-16 px-16' key={`${item.user_id}`} onClick={goProfile}>
        <div style={{ width: '40px', height: '40px' }}>
            <ProfilePicture imgUrl={item.profilePicture} width={40} height={40} no_edit={true} handleClick={goProfile} />
        </div>
        <div className='ml-16'>
            <p className='fs-xxs fw-bold fg-dark tt-uppercase'>{item?.userName}</p>
            <p className='fs-xxs fw-medium fg-dark'>{getUserDisplayName(item)}</p>
        </div>
        <button
            className={isSubscribed ? 'btn red-outline-btn btn-sm fs-tiny fw-extra-bold rounded-xl ml-auto' : 'btn red-btn btn-sm fs-tiny fw-extra-bold rounded-xl ml-auto'}
            onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                handleSubscribe(item.user_id, !isSubscribed, item)
            }}
        >
            {isSubscribed ? 'Subscribed' : 'Subscribe'}
        </button>
    </div>
    {showUnsubscribe && <Unsubscribe user={item} onClose={()=>setShowUnsubscribe(false)} onSubmit={() => handleSubscribeUnsubscribe(item.user_id, !isSubscribed, item)} />}
    </>
}
const EmptyStateContributors = ({ onContribute, onClose }) => {
    const handleContribute = () => {
        onContribute()
        onClose()

    }
    return (<div className='d-flex f-column jcc aic px-32 py-48'>
        <Icon alias={"empty_contributors"} height={120} width={120} />
        <p className='mt-24 fs-sm2 fw-bold fg-black' style={{ textAlign: 'center' }}>Be the first to support the creator</p>
        <button className='btn red-btn w-100 t-48' onClick={handleContribute}>contribute</button>

    </div>)
}
const Stats = ({ user, onClose, index, onContribute, fromProfile = false }) => {
    const [selected, setSelected] = useState(MENU_ITEMS[index - 1])
    const menuRef = useRef(null)
    const dispatch = useDispatch()
    const { loadingSubscribers, loadingSubscriptions, view_user } = useSelector((state) => ({
        loadingSubscribers: state.creation.loadingSubscribers,
        loadingSubscriptions: state.creation.loadingSubscriptions,
        view_user: state.creation.view_user
    }))
    
    // Use view_user from Redux if available, otherwise fall back to user prop
    const displayUser = view_user || user

    // Scroll to center the initially selected item
    useEffect(() => {
        if (menuRef.current && index) {
            const menuContainer = menuRef.current
            const menuItems = menuContainer.children
            const selectedIndex = index - 1 // Convert to 0-based index

            if (menuItems[selectedIndex]) {
                const selectedItem = menuItems[selectedIndex]
                const containerWidth = menuContainer.offsetWidth
                const itemWidth = selectedItem.offsetWidth
                const itemOffsetLeft = selectedItem.offsetLeft

                // Calculate scroll position to center the item
                const scrollPosition = itemOffsetLeft - (containerWidth / 2) + (itemWidth / 2)

                // Smooth scroll to center the selected item
                menuContainer.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                })
            }
        }
    }, [index])

    return (
        <div className='stats-container'>
            <div className="p-relative d-flex aic jcc" style={{ height: '72px' }}>
                <Icon alias="chevron-left" stroke="#0A0F1E" color="#0A0F1E" width={24} onClick={onClose} style={{ position: 'absolute', left: '16px' }} />
                <p className='fs-sm2 fw-bold fg-dark tt-uppercase'>{displayUser?.userName}</p>
            </div>
            <div className="menu-profile stats-menu" ref={menuRef}>
                {MENU_ITEMS.map((el, index) =>
                    <div
                        key={el.name}
                        className={`menu-item stats-menu-item px-16 ${selected.name === MENU_ITEMS[index].name ? 'selected' : ''}`}
                        onClick={() => {
                            setSelected(el)
                        }}
                    >
                        <span className={`fs-real fw-bold`}> {displayUser[el.value] || 0} {el.label}</span>
                    </div>
                )}
            </div>
            <div className='sub-page-container pt-12'>
                {selected.name === "contributors" && displayUser[selected.list]?.length == 0 ? <EmptyStateContributors onContribute={onContribute} onClose={onClose} />
                    : <SubPage 
                        list={displayUser[selected.list] || []} 
                        list_used={selected.list} 
                        onClose={onClose} 
                        fromProfile={fromProfile}
                        user_id={displayUser?.user_id}
                        loading={selected.name === 'subscribers' ? loadingSubscribers : selected.name === 'subscriptions' ? loadingSubscriptions : false}
                    />
                }</div>
        </div>
    )
}

export default Stats